export const actions = {
  /**
   * Fetch details of external form environment based on tenant entry UUID
   * @param {Object} ctx Vuex context
   * @param {String} tenantEntryUUID tenant entry UUID
   */
  async getPlatformDetails({ commit }, tenantEntryUUID) {
    try {
      const platformDetails = await this.$axios.$get('/users/external/platform', {
        params: { tenantEntryUUID: tenantEntryUUID }
      });
      commit('setPlatformDetails', platformDetails);

      if (platformDetails.platFormThemeSettings) {
        // set the theme here
        // setEnvironmentSpecificStyles({}, user.platformTheme);
        commit(
          'user-login/setClientThemeDetails',
          {
            style: platformDetails.platFormThemeSettings.style?.sParseJSON({}),
            styleV2: platformDetails.platFormThemeSettings.styleV2?.sParseJSON({}),
            largeLogo: platformDetails.platFormThemeSettings.largeLogo,
            largeLogoSwitch: platformDetails.platFormThemeSettings.largeLogoSwitch,
            logo: platformDetails.platFormThemeSettings.logo,
            backgroundImage: platformDetails.platFormThemeSettings.backgroundImg,
            backgroundImgOption: platformDetails.platFormThemeSettings.backgroundImgOption,
            isApplied: false
          },
          { root: true }
        );
      }
    } catch (exception) {
      commit('setPlatformDetails', {});
    }
  },
  /**
   * Fetch languages supported external form environment based on tenant entry UUID
   * @param {Object} ctx Vuex context
   * @param {String} tenantEntryUUID tenant entry UUID
   */
  async getAvailableLanguages({ commit }, tenantEntryUUID) {
    try {
      commit(
        'updateLanguages',
        await this.$axios.$get('/api/language/getLanguages/external', {
          params: { tenantEntryUUID: tenantEntryUUID, onlyActive: true }
        }),
        { root: true }
      );
    } catch (exception) {
      commit('updateLanguages', [], { root: true });
    }
  }
};
